module.exports = __webpack_public_path__ + "static/hero-99578b0237fdd2c7b8a8b764d6af3066.png";